import React from 'react'

const Login = () => {
  return (
    <div>
      <h1 className='text-6xl font-bold'>Login</h1>
    </div>
  )
}

export default Login